import {IonContent} from "@ionic/react";

export const AdminIndex: React.FC = () => {
    return (
        <IonContent fullscreen className={"ion-padding"}>
            <p>Show additional info here</p>
        </IonContent>
    );
}